import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ScreeningQuestionnaire = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ScreeningQuestionnaire' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Weight:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Height:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWeight' name='txtWeight' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHeight' name='txtHeight' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h4>Family Physician and/or Primary Health Care Provider:</h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Doctor/Other</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtDoctor3' name='txtDoctor3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                        
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>City</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDoctor' name='txtDoctor' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Instructions: Please answer the following questions by marking an 'X' in the block(s) that applies, if yes, explain your medical treatment, pending treatment, or in need of treatment.
                </p>
                <table>
                    <tr>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes &nbsp;</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> No</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Medical Concerns</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Explanation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical_Yes' name='rbMedical' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical_No' name='rbMedical' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Has a doctor ever said your blood pressure was too high?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation' name='txtExplanation' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical1_Yes' name='rbMedical1' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical1_No' name='rbMedical1' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do you ever have pain in your chest or heart?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation1' name='txtExplanation1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical2_Yes' name='rbMedical2' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical2_No' name='rbMedical2' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Are you often bothered by a thumping of the heart?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation2' name='txtExplanation2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical3_Yes' name='rbMedical3' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical3_No' name='rbMedical3' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Does your heart often race?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation3' name='txtExplanation3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical4_Yes' name='rbMedical4' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical4_No' name='rbMedical4' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do you ever notice extra heartbeats or skipped beats?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation4' name='txtExplanation4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical5_Yes' name='rbMedical5' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical5_No' name='rbMedical5' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Are your ankles often badly swollen?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation5' name='txtExplanation5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical6_Yes' name='rbMedical6' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical6_No' name='rbMedical6' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>In hospital last 4 years
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation6' name='txtExplanation6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical7_Yes' name='rbMedical7' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical7_No' name='rbMedical7' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do cold hands or feet trouble you even in hot weather?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation7' name='txtExplanation7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical8_Yes' name='rbMedical8' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical8_No' name='rbMedical8' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Has a doctor ever said that you have or have had heart trouble, an abnormal electrocardiogram (ECG or EKG), heart attack or coronary?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation8' name='txtExplanation8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical9_Yes' name='rbMedical9' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical9_No' name='rbMedical9' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do you suffer from frequent cramps in your legs?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation9' name='txtExplanation9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical10_Yes' name='rbMedical10' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical10_No' name='rbMedical10' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do you often have difficulty breathing?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation10' name='txtExplanation10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical11_Yes' name='rbMedical11' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical11_No' name='rbMedical11' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do you get out of breath long before anyone else?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation11' name='txtExplanation11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical12_Yes' name='rbMedical12' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical12_No' name='rbMedical12' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Do you sometimes get out of breath when sitting still or sleeping?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation12' name='txtExplanation12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical13_Yes' name='rbMedical13' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical13_No' name='rbMedical13' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Has a doctor ever told you your cholesterol level was high?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation13' name='txtExplanation13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical14_Yes' name='rbMedical14' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical14_No' name='rbMedical14' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Has a doctor ever told you that you have an abdominal aortic aneurysm?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation14' name='txtExplanation14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical15_Yes' name='rbMedical15' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedical15_No' name='rbMedical15' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Has a doctor ever told you that you have critical aortic stenosis?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanation15' name='txtExplanation15' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-50'>
                            <span className='eleHeader'> Yes &nbsp;</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> No</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Have you now or recently experienced any of the following:</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Explanation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp_Yes' name='rbMedicalExp' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp_No' name='rbMedicalExp' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Chronic, recurrent or morning cough?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp' name='txtExplanationExp' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp2_Yes' name='rbMedicalExp2' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp2_No' name='rbMedicalExp2' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Episode of coughing up blood?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp2' name='txtExplanationExp2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp3_Yes' name='rbMedicalExp3' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp3_No' name='rbMedicalExp3' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Increased anxiety or depression?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp3' name='txtExplanationExp3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp4_Yes' name='rbMedicalExp4' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp4_No' name='rbMedicalExp4' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Problems with recurrent fatigue, trouble sleeping or increased irritability?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp4' name='txtExplanationExp4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp5_Yes' name='rbMedicalExp5' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp5_No' name='rbMedicalExp5' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Migraine or recurrent headaches?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp5' name='txtExplanationExp5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp6_Yes' name='rbMedicalExp6' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp6_No' name='rbMedicalExp6' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Swollen or painful knees or ankles?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp6' name='txtExplanationExp6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp7_Yes' name='rbMedicalExp7' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp7_No' name='rbMedicalExp7' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Swollen, stiff or painful joints?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp7' name='txtExplanationExp7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp8_Yes' name='rbMedicalExp8' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp8_No' name='rbMedicalExp8' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Back problems?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp8' name='txtExplanationExp8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp9_Yes' name='rbMedicalExp9' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp9_No' name='rbMedicalExp9' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Stomach or intestinal problems, such as recurrent heartburn, ulcers, constipation or diarrhea?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp9' name='txtExplanationExp9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp10_Yes' name='rbMedicalExp10' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp10_No' name='rbMedicalExp10' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Significant vision or hearing problems?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp10' name='txtExplanationExp10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp11_Yes' name='rbMedicalExp11' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp11_No' name='rbMedicalExp11' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Recent change in a wart or a mole?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp11' name='txtExplanationExp11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp12_Yes' name='rbMedicalExp12' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp12_No' name='rbMedicalExp12' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Glaucoma or increased pressure in the eyes?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp12' name='txtExplanationExp12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp13_Yes' name='rbMedicalExp13' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp13_No' name='rbMedicalExp13' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Exposure to loud noises for long periods?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp13' name='txtExplanationExp13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp14_Yes' name='rbMedicalExp14' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp14_No' name='rbMedicalExp14' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>An infection such as pneumonia accompanied by a fever?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp14' name='txtExplanationExp14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp15_Yes' name='rbMedicalExp15' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp15_No' name='rbMedicalExp15' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Significant unexplained weight loss?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp15' name='txtExplanationExp15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp16_Yes' name='rbMedicalExp16' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp16_No' name='rbMedicalExp16' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>A fever, which can cause dehydration and rapid heart beat?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp16' name='txtExplanationExp16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp17_Yes' name='rbMedicalExp17' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp17_No' name='rbMedicalExp17' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>A deep vein thrombosis (blood clot)?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp17' name='txtExplanationExp17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp18_Yes' name='rbMedicalExp18' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp18_No' name='rbMedicalExp18' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>A hernia that is causing symptoms?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp18' name='txtExplanationExp18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp19_Yes' name='rbMedicalExp19' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp19_No' name='rbMedicalExp19' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Foot or ankle sores that won't heal?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp19' name='txtExplanationExp19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp20_Yes' name='rbMedicalExp20' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp20_No' name='rbMedicalExp20' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Persistent pain or problems walking after you have fallen?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp20' name='txtExplanationExp20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp21_Yes' name='rbMedicalExp21' className='add-only' value='1' />  Yes &nbsp;
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMedicalExp21_No' name='rbMedicalExp21' className='add-only' value='2' /> No
                        </td>
                        <td className='w-300'>Eye conditions such as bleeding in the retina or detached retina?
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtExplanationExp21' name='txtExplanationExp21' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Women only answer the following. Do you have:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='cbFoster' id='cbFoster' className='add-only' value='1' /> Menstrual period problems?
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' name='cbFoster1' id='cbFoster1' className='add-only' value='1' /> Significant childbirth - related problems?
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='cbFoster2' id='cbFoster2' className='add-only' value='1' /> Urine loss when you cough, sneeze or laugh?
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Date of the last pelvic exam and / or Pap smear &nbsp;
                    <input type='text' id='txtPelvic' name='txtPelvic' className='add-only w-350 custom-add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Are you on any type of hormone replacement therapy?</span>
                    <input type='radio' id='rbHormone_Yes' name='rbHormone' className='add-only' value='1' />  Yes &nbsp;
                    <input type='radio' id='rbHormone_No' name='rbHormone' className='add-only' value='0' /> No
                </p>

                <p className='w-750'><h4>Men and women answer the following:</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>List any prescription medications you are now taking:</span>
                    <textarea id='txtComments1' name='txtComments1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List any self-prescribed medications, dietary supplements, or vitamins you are now taking:</span>
                    <textarea id='txtComments2' name='txtComments2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Date of last complete physical examination: &nbsp;
                    <input type='date' id='txtPhysicalExamination' name='txtPhysicalExamination' className='add-only w-200 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal' id='cbNormal' className='add-only' value='1' />  Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal1' id='cbNormal1' className='add-only' value='1' />  Abnormal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal2' id='cbNormal2' className='add-only' value='1' />  Never
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal3' id='cbNormal3' className='add-only' value='1' />  Can't remember
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Date of last chest X-ray: &nbsp;
                    <input type='date' id='txtPhysicalExamination1' name='txtPhysicalExamination1' className='add-only w-200 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal4' id='cbNormal4' className='add-only' value='1' />  Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal5' id='cbNormal5' className='add-only' value='1' />  Abnormal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal6' id='cbNormal6' className='add-only' value='1' />  Never
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal7' id='cbNormal7' className='add-only' value='1' />  Can't remember
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Date of last electrocardiogram (EKG or ECG): &nbsp;
                    <input type='date' id='txtPhysicalExamination2' name='txtPhysicalExamination2' className='add-only w-200 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNorma8' id='cbNorma8' className='add-only' value='1' />  Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal9' id='cbNormal9' className='add-only' value='1' /> Abnormal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal11' id='cbNormal11' className='add-only' value='1' /> Never
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal12' id='cbNormal12' className='add-only' value='1' /> Can't remember
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Date of last dental check up: &nbsp;
                    <input type='date' id='txtPhysicalExamination3' name='txtPhysicalExamination3' className='add-only w-200 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNorma13' id='cbNorma13' className='add-only' value='1' />  Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal14' id='cbNormal14' className='add-only' value='1' /> Abnormal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal15' id='cbNormal15' className='add-only' value='1' /> Never
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNormal16' id='cbNormal16' className='add-only' value='1' /> Can't remember
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List any other medical or diagnostic test you have had in the past two years:</span>
                    <textarea id='txtDiagnostic' name='txtDiagnostic' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List hospitalizations, including dates of and reasons for hospitalization:</span>
                    <textarea id='txtDiagnostic1' name='txtDiagnostic1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List any drug allergies:</span>
                    <textarea id='txtDiagnostic2' name='txtDiagnostic2' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Past Medical History</h4></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Check those questions to which your answer is yes
                            </span><span className='small'>(leave others blank).</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever' id='cbFever' className='add-only' value='1' /> Rheumatic Fever
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever1' id='cbFever1' className='add-only' value='1' /> Heart murmur
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever2' id='cbFever2' className='add-only' value='1' /> Diseases of the arteries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever3' id='cbFever3' className='add-only' value='1' /> Varicose veins
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever4' id='cbFever4' className='add-only' value='1' /> Arthritis of legs or arms
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever5' id='cbFever5' className='add-only' value='1' /> Jaundice or gall bladder problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever6' id='cbFever6' className='add-only' value='1' /> Phlebitis (inflammation of a vein)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever7' id='cbFever7' className='add-only' value='1' /> Dizziness or fainting spells
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever8' id='cbFever8' className='add-only' value='1' /> Epilepsy or seizures
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever9' id='cbFever9' className='add-only' value='1' /> Stroke
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever10' id='cbFever10' className='add-only' value='1' /> Diphtheria
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever11' id='cbFever11' className='add-only' value='1' /> Scarlet Fever
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever12' id='cbFever12' className='add-only' value='1' /> Infectious mononucleosis
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever13' id='cbFever13' className='add-only' value='1' /> Nervous or emotional problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever14' id='cbFever14' className='add-only' value='1' /> Anemia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever15' id='cbFever15' className='add-only' value='1' /> Thyroid problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever16' id='cbFever16' className='add-only' value='1' /> Pneumonia
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever17' id='cbFever17' className='add-only' value='1' /> Bronchitis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever18' id='cbFever18' className='add-only' value='1' /> Asthma
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever19' id='cbFever19' className='add-only' value='1' /> Abnormal chest X-ray
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever20' id='cbFever20' className='add-only' value='1' /> Other lung disease
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever21' id='cbFever21' className='add-only' value='1' /> Injuries to back, arms, legs or joint
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbFever22' id='cbFever22' className='add-only' value='1' /> Broken bones
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbFever23' id='cbFever23' className='add-only' value='1' /> Diabetes or abnormal blood-sugar tests
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbFever24' id='cbFever24' className='add-only' value='1' /> Heart attack if so, how many years ago? &nbsp;
                            <input type='text' id='txtHeart' name='txtHeart' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments3' name='txtComments3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you in any pain today?</span>
                    <input type='radio' id='rbHormone2_Yes' name='rbHormone2' className='add-only' value='1' />  Yes &nbsp;
                    <input type='radio' id='rbHormone2_No' name='rbHormone2' className='add-only' value='0' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please rate your pain by checking the one number is No Pain and 10 as the worst pain.</span>
                </p>
                <table>
                    <tr>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yes' name='rbPain' className='add-only' value='1' /> 0
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbPain_Ye' name='rbPain' className='add-only' value='2' /> 1 No Pain
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Ys' name='rbPain' className='add-only' value='3' /> 2
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yu' name='rbPain' className='add-only' value='4' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yi' name='rbPain' className='add-only' value='5' /> 4
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yo' name='rbPain' className='add-only' value='6' /> 5
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yp' name='rbPain' className='add-only' value='7' /> 6
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Ya' name='rbPain' className='add-only' value='8' /> 7
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yd' name='rbPain' className='add-only' value='9' /> 8
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPain_Yf' name='rbPain' className='add-only' value='10' /> 9
                        </td>
                        <td className='w-120'>
                            <input type='radio' id='rbPain_Yg' name='rbPain' className='add-only' value='11' /> 10 worst pain
                        </td>
                    </tr>
                </table>
                <p className='w-750'>I declare that my answers are true to the best of my knowledge and belief.</p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Screening reviewed by staff, the following recommendations are listed below:</span>
                    <textarea id='txtComments5' name='txtComments5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments6' name='txtComments6' className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}

